export const team = [
  {
    img: '/assets/team/alvaro.png',
    name: 'Álvaro Barrera',
    role: 'Fundador · CEO',
    bio: 'Marketing digital, emprendimiento y creación de comunidades online. Más de 8 años construyendo negocios reales.',
  },
  {
    img: '/assets/team/carlos.png',
    name: 'Carlos Montojo',
    role: 'Emprendimiento & Ecommerce',
    bio: 'CEO y fundador de Mim Shoes. Ha construido una marca desde cero hasta convertirla en referente del ecommerce de moda en España.',
  },
  {
    img: '/assets/team/blanca.png',
    name: 'Blanca Barrera Aguacatte',
    role: 'Lifestyle & Eventos',
    bio: 'Conocida como Lady Aguacatte, fundadora del catering Aguacatte —favorito de la sociedad madrileña— e interiorista.',
  },
  {
    img: '/assets/team/guillermo.png',
    name: 'Guillermo Milans',
    role: 'Wellness & Nutrición Funcional',
    bio: 'CEO y cofundador de Baïa Food, pionera europea en nutrición funcional con base científica.',
  },
  {
    img: '/assets/team/andrea.png',
    name: 'Andrea Klimowitz',
    role: 'Wellness & Mindfulness',
    bio: 'Coach transpersonal, licenciada en Psicología y fundadora de Quantum Union. Especialista en breathwork, meditación y bienestar consciente.',
  },
  {
    img: '/assets/team/carmen.png',
    name: 'Carmen Navarro',
    role: 'Belleza & Estética Holística',
    bio: 'Pionera de la estética en España desde 1973. Más de 50 años marcando tendencia.',
  },
  {
    img: '/assets/team/lucia.png',
    name: 'Lucía Ruiz Lafita',
    role: 'Gastronomía & Lifestyle',
    bio: 'Fundadora de Delirium Catering, el catering de alta cocina referente en Madrid. Formada en ICADE y Le Cordon Bleu París.',
  },
  {
    img: '/assets/team/beatriz.png',
    name: 'Beatriz de los Mozos',
    role: 'Emprendimiento & Moda',
    bio: 'Fundadora de Flabelus, la marca de calzado artesanal que ha conquistado España, México, Colombia y EEUU.',
  },
  {
    img: '/assets/team/agatha.png',
    name: 'Agatha Ruiz de la Prada',
    role: 'Moda & Diseño',
    bio: 'Diseñadora con más de 40 años de carrera. Icono del color y la creatividad en la moda española e internacional.',
  },
];
